let $buildAccordion = document.querySelector('.build-accordion');

function buildAccordion() {
    let $buildAccordionItems = $('.build-accordion__items');

   $($buildAccordionItems).each( function (index, item) {
       $(item).find('.build-accordion__items-head').on('click', function () {
           accordionOpen(item)
        })
       $(item).find('.build-accordion__items-main .link--accordion').on('click', function () {
           // $(item).find('.build-accordion__items-main .link--accordion').parent()
           accordionClose();
       })
       $(item).find('.build-accordion__items-main .close-mobile').on('click', function () {
           // $(item).find('.build-accordion__items-main .link--accordion').parent()
           accordionClose();
       })
    })

    function accordionOpen(item) {
        let statusClass = $(item).find('.build-accordion__items-head').hasClass('build-accordion__items-head--active')
        accordionClose();
        if(!statusClass) {
            $(item).find('.build-accordion__items-head').addClass('build-accordion__items-head--active')
            $(item).find('.build-accordion__items-main').addClass('build-accordion__items-main--active').slideDown(250);
        } else {
            $(item).find('.build-accordion__items-head').removeClass('build-accordion__items-head--active')
            $(item).find('.build-accordion__items-main').removeClass('build-accordion__items-main--active').slideUp(250);
        }
    }

    function accordionClose() {
        $($buildAccordionItems).each( function (index, item) {
            $(item).find('.build-accordion__items-head').removeClass('build-accordion__items-head--active')
            $(item).find('.build-accordion__items-main').removeClass('build-accordion__items-main--active').slideUp(250);
        })
    }



    accordionClose();

    $($buildAccordionItems[0]).find('.build-accordion__items-head').addClass('build-accordion__items-head--active')
    $($buildAccordionItems[0]).find('.build-accordion__items-main').addClass('build-accordion__items-main--active').slideDown(250);

}

if($buildAccordion) {
    buildAccordion();
}